// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application, definitionsFromContext } from "./stimulus";

const shared = require.context("./controllers", true, /_controller\.js$/);
application.load(definitionsFromContext(shared));
